<template>
	<div class="box">
		<div class="logo">
			<img src="../assets/images/login-logo.png" alt="" />
		</div>
		<div class="concat">
			<div class="title">如需试用请联系</div>
			<div class="card">
				<div class="card-box">电话：18767138236 闻经理</div>
				<div class="line"></div>
				<div class="card-box">邮箱：info@skiffenergy.com</div>
			</div>
		</div>

		<div class="footer" @click="goLogin">直接登录</div>
	</div>
</template>

<script setup>
	import { reactive } from "vue";
	import { useRouter, useRoute } from "vue-router";
	const router = useRouter();

	const goLogin = () => {
		router.push("/login");
	};
</script>

<style lang="less" scoped>
	.box {
		.concat {
			margin-top: 56px;
			.title {
				height: 26px;
				opacity: 0.85;
				font-family: PingFangSC-Medium;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				letter-spacing: 0;
				text-align: center;
				line-height: 26px;
			}

			.card {
				height: 149px;
				background: #ffffff;
				border: 1px solid #00000029;
				border-radius: 4px;
				margin-top: 25px;
				padding: 25px 1.25vw;

				&-box {
					height: 24px;
					opacity: 0.85;
					font-family: PingFangSC-Medium;
					font-weight: 600;
					font-size: 16px;
					color: #000000;
					letter-spacing: 0;
					text-align: center;
					line-height: 24px;
				}

				.line {
					height: 1px;
					opacity: 0.16;
					border: 1px solid #000000;
					margin: 25px 0px;
				}
			}
		}
	}
</style>
